<template>
  <section class="link-section">
    <h4 class="link-section__title" v-text="title" />

    <ul class="link-section__list">
      <li
        class="link-section__list-item"
        v-for="(link, index) in linksData"
        :key="`LinkSectionListItem${index}`"
      >
        <link-item-parts :linkData="link" :key="`linkItemParts${index}`" />
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { LinkData } from '@/components/LinkPage/LinkPane.vue'
import LinkItemParts from '@/components/LinkPage/LinkPane/LinkItemParts.vue'

/**
 * Link セクション
 */
export default defineComponent({
  name: 'LinkSection',
  components: {
    LinkItemParts,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    linksData: {
      type: Array as PropType<LinkData[]>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.link-section {
  width: 100%;
  max-width: 800px;

  &__title {
    padding: min(#{convertPXtoVW(10)}, 10px) min(#{convertPXtoVW(16)}, 16px);
    font-family: $fontSignup;
    font-weight: 500;
    font-size: min(#{convertPXtoVW(13)}, 13px);
    line-height: 1.54;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;
    color: rgba(0, 0, 0, 0.7);
    background: #e5e5e5;
  }

  &__list {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: min(#{convertPXtoVW(8)}, 8px) min(#{convertPXtoVW(5)}, 5px);
    max-width: 800px;
    padding: min(#{convertPXtoVW(16)}, 16px);

    @media screen and (min-width: $responsiveTabletWidth) {
      padding: 16px 10px;
    }
  }
}
</style>
